import React, { useState, useEffect } from 'react'
import getImage from 'common/getImage'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import NoteList from '../../annotate/noteList'
import styles from './index.module.less'

export default ({
  setIsAnnotate,
  isAnnotate,
  notes,
  setNotes,
  onActiveNoteIndex,
  isMove,
  loginUserInfo,
  currentImage,
}) => {
  const [originImage, setOriginImage] = useState<any>()

  useEffect(() => {
    getImage(currentImage.mainUrl).then((img) => {
      setOriginImage({
        width: img.naturalWidth,
        height: img.naturalHeight,
      })
    }).catch(() => {
      setOriginImage({
        width: currentImage?.width,
        height: currentImage?.height,
      })
    })
  }, [currentImage])

  return <div className={styles.annotationInfo}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.mainTitle}>
        批注 <span style={{
        marginLeft: '8px',
        fontWeight: '600',
        color: 'var(--m-text-3)' }}
        >{notes.length}</span>
      </div>
    </div>
    <div style={{ marginTop: '12px' }}>
      <Button
        active={isAnnotate}
        onClick={() => {
          setIsAnnotate(!isAnnotate)
        }}
      >
        <Icon type="m-tianjia_miaobian" style={{ marginRight: '8px' }} />新增批注
      </Button>
    </div>
    <div className="note-list-container">
      <NoteList
        originImage={originImage}
        mainUrl={currentImage.mainUrl}
        notes={notes}
        setNotes={setNotes}
        setIsAnnotate={setIsAnnotate}
        setActiveNoteIndex={onActiveNoteIndex}
        isAnnotate={isAnnotate}
        isMove={isMove}
        loginUserInfo={loginUserInfo}
        _onChange={undefined}
      />
    </div>
  </div>
}
